module.exports = __webpack_public_path__ + "img/iPad_sml-44141c86e7f3d032ddbb78dd77ffb812.png";